import React from "react";

import Heading from "home/components/Heading";
import Footer from "home/components/Footer";
import ContentSection from "home/components/ContentSection";

import styled from "styled-components";

import { Breadcrumbs, Link, Typography } from "@material-ui/core";

const Page = styled.div`
  height: calc(100vh - 85px);
`;

export default () => {
  return (
    <div>
      <Heading maxWidth={1000} showButtons={true} />
      <Page>
        <ContentSection maxWidth={1000}>
          <div>
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit" href="/">
                RoboPPA Home
              </Link>
              <Link color="inherit" href="/#/Blog">
                Blog Posts
              </Link>
              <Typography color="textPrimary">March 7, 2021</Typography>
            </Breadcrumbs>
          </div>
          <h1>
            Performance Analysis of Managed Portfolios with Transfers and Proper
            Benchmarks
          </h1>
          <h2>
            Benchmark portfolios are market alternatives to managed portfolios
            and typically have lower expenses. They may also have preferred Risk
            and Return properties. The preferred portfolio depends on the proper
            analysis of their comparative performance.
          </h2>
          <h3>The Problem</h3>
          <p>
            Out of pocket cash transfers or security transfers from one
            portfolio to another are a common occurrence in managed portfolios
            but not benchmark portfolios. The problem is that these
            contributions and withdrawals seriously affect the calculation of a
            managed portfolio’s performance. The same transfer amount and timing
            must be applied to benchmarks to obtain a comparable performance
            analysis.
          </p>
          <h3>Types of Portfolio Transfers</h3>
          <p>
            Transfers are defined as Contributions or Withdrawals external to or
            from the managed portfolio. The transfers can be in the form of cash
            or securities originating directly from or to the owner or an
            external portfolio. This could include cash contributed or withdrawn
            to pay Management Fees. Transactions within the portfolio, such as
          </p>
          <ul>
            <li>
              changes in the asset allocations inside the managed portfolio,{" "}
            </li>
            <li>interest/dividends/splits/spinoffs, </li>
            <li>brokerage fees, and </li>
            <li>asset purchases and sales</li>
          </ul>
          <p>are not Transfers.</p>
          <h3>A Common Practice</h3>
          <p>
            A common practice is to simply show a plot of the benchmark’s growth
            in value from some standardized starting value, such as $100,000,
            over the analysis period. Whether this informative to a portfolio’s
            owner, depends on the portfolio’s transfers. In some cases, the
            portfolio’s monthly values, after transfers, are included in the
            chart versus the benchmark’s monthly values. Unfortunately, the
            benchmark is not typically adjusted for the portfolio’s transfers.
            Depending on the size and timing of the transfers, the effect on
            comparative ending values can be large.
          </p>
          <h3>An Example</h3>
          <p>
            To illustrate the problems with omitting the portfolio’s transfers
            in the benchmark, we show the RoboPPA™ results from a December 31,
            2019, $100,000 investment in the market index ETF, with a $20,000
            portfolio contribution made post crash on March 31, 2020 and also
            invested in the market index. In this example, the logical benchmark
            is the market equity index; however, the index is not adjusted for
            the transfers that occurred in the portfolio. A chart of the
            portfolio and unadjusted benchmark is shown below.
          </p>
          <p>
            RoboPPA™ calculates Aug. 31, 2020 portfolio ending value, after
            transfers, of $123,958. The ending value of the unadjusted benchmark
            is $97,116, a substantially smaller value, representing a -27% error
            relative to the starting portfolio value. Because the portfolio is
            invested in the benchmark, its ending value should also be $123,958,
            as correctly calculated by RoboPPA™.
          </p>
          <p>
            <img src="/images/blogs/3-7-2021-1.png" alt="Chart"/>
          </p>
          <h3>Conclusion</h3>
          <p>
            It is imperative that benchmark portfolios are adjusted for the
            transfers that occur in a managed portfolio. Failure to do so, may
            result in a large error in performance. In this example, the dollar
            value-added by the portfolio is vastly overstated because of the
            $20,000 omission of the contribution and its timing. If the transfer
            had been a withdrawal post March crash, an error favoring the
            benchmark would have occurred.
          </p>
          <h3>Caveats</h3>
          <p>
            The analysis contained in this document is based on a fictitious
            portfolio and the results are not to be interpreted as
            representative of real markets and asset classes. This example is
            based upon our opinion and interpretation of the information and
            results, which may be incomplete or incorrect. Details on the
            performance calculations are available on www.RoboPPA.com.
          </p>
        </ContentSection>
        <Footer />
      </Page>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/blog/blogPosts/3-7-2021.js